import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPopupState } from '../../model/configuratorSlice';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import { PopupState } from '../../model/constants';

const LegalNote = () => {
  const { legalSettings } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  const closePopupHandler = () => {
      dispatch(setPopupState(PopupState.None));
  };

  const isLegalNoteOpened = true;
  return (
    <div className={`legal-note-popup ${isLegalNoteOpened ? ' opened' : ''}`}>
      <div className={`background${isLegalNoteOpened ? ' opened' : ''}`} />
      <div className={`panel${isLegalNoteOpened ? ' opened' : ''}`}>
        <button
          type="button"
          className="close-button"
          onClick={closePopupHandler}
        >
          <CloseButton className="icon" />
        </button>
        <div className="header">Nota Legal</div>
        <div className="body">{legalSettings.legalNote}</div>
      </div>
    </div>
  );
};
export default LegalNote;
